import { useEffect } from "react";

function modifyUrl(url) {
  const targetUrl = new URL(url);
  const currentParams = new URLSearchParams(window.location.search);

  // Append all current params to the target URL (without overwriting existing ones)
  for (const [key, value] of currentParams.entries()) {
    if (!targetUrl.searchParams.has(key)) {
      targetUrl.searchParams.append(key, value);
    }
  }

  return targetUrl.toString();
}

function isExternal(url) {
  try {
    const parsed = new URL(url, window.location.href);
    return parsed.origin !== window.location.origin;
  } catch {
    return false;
  }
}

export default function useExternalNavigationInterceptor() {
  useEffect(() => {
    function handleClick(e) {
      const anchor = e.target.closest("a[href]");
      if (!anchor || e.defaultPrevented) return;

      const href = anchor.getAttribute("href");
      if (
        !href ||
        href.startsWith("#") ||
        href.startsWith("javascript:") ||
        anchor.target === "_blank"
      ) {
        return;
      }

      const fullUrl = new URL(href, window.location.href);

      if (isExternal(fullUrl.href)) {
        e.preventDefault();
        window.location.href = modifyUrl(fullUrl.href);
      }
    }

    document.addEventListener("click", handleClick, true);

    return () => {
      document.removeEventListener("click", handleClick, true);
    };
  }, []);
}
